/* ============================================================
   Shelly — theme interactions
   Reserve button -> add product to cart -> native /checkout.

   NOTE: Email capture (reservation "Notify me" + footer signup) is now
   handled natively by Shopify via {% form 'customer' %} in the section
   liquid — no JS, no third party. A submit creates a Subscribed customer.
   ============================================================ */
(function () {
  "use strict";

  /* ============================================================
     RESERVE ($9.99) — add the reservation product to the cart,
     then send the visitor to Shopify's native checkout.
     The <a> href is a /cart/{variant}:1 permalink, so this still
     works as a no-JS fallback if the fetch fails.
     ============================================================ */
  document.querySelectorAll('[data-reserve-checkout]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = link.getAttribute("data-variant-id");
      if (!id) return; // nothing to add — let the href do its thing
      e.preventDefault();
      link.style.pointerEvents = "none";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { window.location.href = link.getAttribute("href"); }); // permalink fallback
    });
  });

  // Pending reserve button (product not connected/published) — don't navigate anywhere.
  document.querySelectorAll('[data-reserve-pending]').forEach(function (btn) {
    btn.addEventListener("click", function (e) { e.preventDefault(); });
  });
})();
